import Route from '@ember/routing/route';
import { instrumentRoutePerformance } from '@sentry/ember';

class OperationsTeamsTeamHomeRoute extends Route {
  model() {
    return this.modelFor('operations.teams.team');
  }
}

export default instrumentRoutePerformance(OperationsTeamsTeamHomeRoute);
